import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import tabs from './reducers/tabs'
import loading from './reducers/loading'
import roleConfig from './reducers/role'
import order from './reducers/order'
import limits from './reducers/limits'
import home from './reducers/home'

const modules = combineReducers({
  loading,    // 加载动画
  tabs,    // 主页面tabs
  roleConfig,  // 角色页面配置
  order,     // 订单
  limits,      // 权限
  home
})

const store = createStore(modules, compose(
  // applyMiddleware(thunk),
  window.devToolsExtension && window.devToolsExtension() // 配置redux 开发工具
));

export default store